import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mentionRecommendationText: {
		id: 'editor-wrapper.mention-recommendations.mention-recommendation-text',
		defaultMessage: 'Add mentions:',
		description: 'Add a user mention in the editor',
	},
});
